
module.exports = {
  language: {
    name: 'English',
    code: 'en'
  },
  user: {
    login:'login',
    register:'register',
    loginUsername:'please input email or phone',
  },
  company: {
    name: 'Beijing Shunfuda Logistics Co., Ltd'
  },
  navgate: {
    item1: 'About Us',
    item2: 'advantages',
    item3: 'development',
    item4: 'cooperative client',
    item5: 'Vehicle resources'
  },
  waybillQuery: {
    title: 'Waybill query',
    placeholder: 'Please enter the tracking number for inquiry',
    text1: 'Aging security',
    text2: 'Network query',
    text3: 'delivery coverage',
    text4: 'logistics tracking'
  },
  companyProfile: {
    title: 'About Us',
    text1: 'SFD was founded in Beijing in 2003 with a registered capital of 10 million RMB.',
    text2: 'SFD is a freight forwarder approved by the Ministry of Commerce and has a road operation license issued by the Ministry of transport,It’s registered under the customs departmento do transportation under the customs supervision .At the same time, it was rated as one of the top 100 integrity enterprises in road transportation and the green fleet of urban freight transportation，It is a highly competitive logistics company in China.',
    text3: 'Core services include international agent transportation of various goods，Customs declaration and inspection declaration of import and export goods by sea and air，domestic transportation of general goods，import and export trade agency，allocation、 distribution、storage yard、warehousing、bonded warehousing and other related value-added services of imported goods .',
    text4: 'SFD has 20 years of operation experience,It has a mature operation system, a sound logistics electronic system, a professional operation team and processes、a transportation fleet with national standard exhaust emission , It has cooperated with many well-known enterprises with modern management methods since the establishment of the company.',
    text5: "SFD's services cover the whole country 、established long-term and stable cooperative relations with many enterprises at home and abroad,it can adapt to domestic and international business needs to ensure safe、 fast and reliable services for customers."
  },
  TransQualification: {
    title: 'Transportation Qualification'
  },
  operatingAdvantages: {
    title: 'Advantages Of Company',
    text1: 'The staff have high service awareness, rich operation experience and positive service attitude',
    text2: 'It has official formal qualification certification, professional logistics enterprise, Integrity enterprise certification, green fleet certification, etc',
    text3: 'We have professional logistics personnel, standardized operation procedures and systematic service procedures',
    text4: 'There are value-added services such as insured transportation, packaging, picking up, delivery and receipt',
    text5: 'Effective protection measures to ensure the safety of goods during transportation',
    text6: 'Strong operation support system, bar code marking, office automation and logistics information synchronization',
  },
  managementSystem: {
    title1: 'Company business Philosophy',
    text1: 'SFD adheres to the concept of "common growth and common development"，it always adhere to the principle of "providing customers with the lowest logistics cost and the best logistics transportation scheme with our own advantages",focusing on high-quality service, take Beijing as the center and radiate all over China. ',
    title2: 'Management System',
    text2: 'SFD has been exploring for 20 years since its establishment ,constantly improving itself, also integrates market advantageous resources to meet the high-end transportation customized services of enterprises, so that customers can enjoy truly high-end transportation services.',
    text_m1: 'SFD strictly follows the KPI indicator assessment mode',
    text_m2: 'Timely meet the demand for car booking',
    text_m3: 'Pick up goods on time as required',
    text_m4: 'Goods are delivered to customers on time and accurately',
    text_m5: 'Strictly protect goods during transportation',
    text_m6: 'The documents shall be consistent and recorded in time',
    text_m7: 'All indexes needs to be above 98%, Accept customer supervision and assessment.'
  },
  businessTrends: {
    title: "Company Development",
    text1: "The company's business covers the whole country The proportion of each district is shown in the figure",
    text2: 'Business growth ratio chart'
  },
  cooperativeClient: {
    title: 'Major Customers',
    items: [
      {
        name: 'Procter & Gamble',
        dec: 'Main service area：All over the china',
        year: 'cooperation time(year)：19'
      },
      {
        name: 'Yishangmejie',
        dec: 'Main service area：All over the china',
        year: 'cooperation time(year)：19'
      },
      {
        name: 'Volvo',
        dec: 'Main service area：Northwest、Central、Northeast、 North',
        year: 'cooperation time(year)：7'
      },
      {
        name: 'SMC',
        dec: 'Main service area：Northwest、Central、Northeast、 North',
        year: 'cooperation time(year)：5'
      },
      {
        name: 'Tieli international freight',
        dec: 'Main service area：Northeast、 North、Central',
        year: 'cooperation time(year)：9'
      },
      {
        name: 'Jacobi',
        dec: 'Main service area：Northwest、Northeast、 North',
        year: 'cooperation time(year)：11'
      },
      {
        name: 'Tetra Pak Beijing',
        dec: 'Main service area：All over the china',
        year: 'cooperation time(year)：19'
      }
    ]
  },
  vehicleResources: {
    title: 'Vehicle Resources',
    leftDiv: {
      text1: 'High value commercial insurance',
      text2: 'Integrated resources available assistance vehicles 600+',
      text3: 'Vehicles with national v emission standards or above\n'
    },
    rightDiv: {
      text1: '20 and 40 foot container truck',
      text2: '4.2-17.5m van',
      text3: '6.8-17.5m refrigerated truck',
      text4: '7.2-16.5m high-sided truck',
      text5: 'Special large transport vehicles'
    }
  },
  footerAll: {
    companyName: 'Beijing Shunfuda Logistics Co., Ltd',
    text1: {
      i: 'Relation',
      Q: 'Ray dong'
    },
    text2: {
      i: 'Phone',
      Q: '13910209660'
    },
    text3: {
      i: 'Email',
      Q: 'honggangdong@163.com'
    },
    text4: {
      i: 'Address',
      Q: 'Room 1605, Building 6, Area I, Hesheng World Village, Jingkai District, Beijing'
    },
    placeholder: {
      n1: 'name',
      n2: 'phone',
      n3: 'email',
      n4: 'message contents'
    },
    btn: 'submit',
    declare: 'property in copyright：Beijing Shunfuda Logistics Co., Ltd'
  }
}



// WEBPACK FOOTER //
// ./src/components/language/en.js